import { Box, Grid, LinearProgress, Typography } from '@mui/material'
import { useAppDispatch, useAppSelector } from '../../redux/hook'
import DTRightPane from './DTRightPane'
import { ReactElement, useEffect } from 'react'
import {
    fetchDataTypes,
    fetchMetaPropertiesOfAttributes,
} from '../../services/dtServices'
import {
    setDataTypes,
    setAttributeMetaDataOptions,
} from '../../redux/slices/dtStudioSlice'
import theme from '../../theme/theme'
import DTLeftPane from './DTLeftPane'
import { UserPermissions } from '../../constants/constants'
import { useTranslation } from 'react-i18next'
import { useRoutePermission } from '../../hooks/useRoutePermission'

const DTStudio = (): ReactElement => {
    const { t, i18n } = useTranslation()
    const org = useAppSelector((state) => state.org.org)
    const dispatch = useAppDispatch()
    //checking the permissions, if user doesn't have permission. redirecting to home
    const allowed = useRoutePermission([
        UserPermissions.ORG_ADMIN,
        UserPermissions.SYSTEM_READER,
    ])
    const language = i18n.language

    useEffect(() => {
        if (org?.id) {
            fetchDataTypes(org?.id || '').then((res: string[]) => {
                dispatch(setDataTypes(res))
            })
            fetchMetaPropertiesOfAttributes(org?.id || '').then((res) => {
                dispatch(setAttributeMetaDataOptions(res))
            })
        }
    }, [org, language, dispatch])

    if (!org) {
        return <LinearProgress />
    }
    return allowed ? (
        <Grid
            sx={{
                margin: '30px',
                border: `1px solid ${theme.palette.primary.main}`,
                borderRadius: '20px',
                overflow: 'hidden',
            }}
        >
            <Grid
                sx={{
                    alignItems: 'center',
                    p: 3,
                    borderBottom: `1px solid ${theme.palette.primary.main}`,
                }}
            >
                <Typography
                    variant="h4"
                    component="h2"
                    sx={{ color: '#00797a' }}
                >
                    {t('networkAdmin')}
                </Typography>
            </Grid>
            <Grid
                container
                sx={{
                    display: 'flex',
                    flexWrap: 'nowrap',
                }}
            >
                <DTLeftPane />
                <DTRightPane />
            </Grid>
        </Grid>
    ) : (
        <Box></Box>
    )
}

export default DTStudio
